import { JourneyPath } from './landing-content';

/** Which KΛI nudge to show for a given step index — matches Alternative D logic. */
export function nudgeForStep(
  stepIndex: number,
  nudges: JourneyPath['nudges'],
): string {
  return nudges[stepIndex <= 1 ? 0 : stepIndex <= 3 ? 1 : 2];
}
